const ACCEPT_CLASSES = "bg-accent hover:bg-accent-strong"
const DANGER_CLASSES = "bg-danger-fg hover:opacity-90"
const DEFAULT_TITLE = "Please confirm"
const DEFAULT_ACCEPT = "Confirm"

function labelOf(submitter: HTMLElement | null | undefined): string {
  if (submitter instanceof HTMLInputElement) return submitter.value
  return submitter?.textContent?.trim() ?? ""
}

function isDestructive(form: HTMLFormElement): boolean {
  const method = form.querySelector<HTMLInputElement>("input[name=_method]")?.value ?? form.method
  return method.toLowerCase() === "delete" || form.dataset.confirmTone === "danger"
}

export function confirmWithDialog(message: string, form: HTMLFormElement, submitter?: HTMLElement | null): Promise<boolean> {
  const dialog = document.getElementById("confirm-dialog") as HTMLDialogElement | null
  if (dialog === null) {
    console.error("confirm-dialog is missing from the layout; the action was not confirmed")
    return Promise.resolve(false)
  }

  const label = labelOf(submitter)
  const accept = dialog.querySelector<HTMLButtonElement>("[data-confirm-accept]")
  const cancel = dialog.querySelector<HTMLButtonElement>("[data-confirm-cancel]")
  const danger = isDestructive(form)

  dialog.querySelector("[data-confirm-title]").textContent = form.dataset.confirmTitle ?? (label === "" ? DEFAULT_TITLE : `${label}?`)
  dialog.querySelector("[data-confirm-message]").textContent = message
  accept.textContent = label === "" ? DEFAULT_ACCEPT : label
  accept.classList.remove(...ACCEPT_CLASSES.split(" "), ...DANGER_CLASSES.split(" "))
  accept.classList.add(...(danger ? DANGER_CLASSES : ACCEPT_CLASSES).split(" "))

  dialog.returnValue = ""
  dialog.showModal()
  ;(danger ? cancel : accept).focus()

  return new Promise(resolve => {
    dialog.addEventListener("close", () => resolve(dialog.returnValue === "confirm"), { once: true })
  })
}

export function installConfirmDialog(): void {
  window.Turbo.config.forms.confirm = confirmWithDialog
}
